<script setup lang="ts">
import SVG_GAME_INTRO from '~/assets/svg/game-intro.svg'
import SVG_LINK_ICON from '~/assets/svg/link.svg'

withDefaults(defineProps<{
  content: string
  gameName: string
  isWebGame: boolean
  controlExplain: string
}>(), {
  content: '',
  gameName: '',
  isWebGame: false,
  controlExplain: '',
})

const teachVideoLinks = [
  {
    name: 'Full Setup Guide',
    href: 'https://www.youtube.com/watch?v=QwXXU7gn9Wo&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=2&ab_channel=EasyFun',
  },
  {
    name: 'Zoom Feature',
    href: 'https://www.youtube.com/watch?v=Qg-w5IDq-aE&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=3&ab_channel=EasyFun',
  },
  {
    name: 'Custom Clicks',
    href: 'https://www.youtube.com/watch?v=J2Tz8NIh-3Q&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=1&ab_channel=EasyFun',
  },
  {
    name: 'Camera Mouse Lock',
    href: 'https://www.youtube.com/watch?v=ZE0hkhzFsV4&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=4&ab_channel=EasyFun',
  },
  {
    name: 'Movement Controls',
    href: 'https://www.youtube.com/watch?v=m5nODF2sa1g&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=5&ab_channel=EasyFun',
  },
  {
    name: 'Clicks and Combo',
    href: 'https://www.youtube.com/watch?v=NMiQpLFm88A&list=PLZ9o8waRdTL_BGOM8tpEAsh10vfn23_Vn&index=6&ab_channel=EasyFun',
  },
]
</script>

<template>
  <section class="w-full flex flex-wrap items-center">
    <div class="w-full flex flex-col">
      <div class="flex items-center">
        <SVG_GAME_INTRO />
        <span class="mis-2 text-6 c-#fff c-op-90 font-normal font-[Bebas_Neue]">
          {{ $t('gameDetail.gameIntroTitle') }}
        </span>
      </div>
      <div v-if="!isWebGame" class="mt-4 w-full rd-4 bg-gray-2 p-4">
        <h2 class="text-6 c-#fff c-op-90 font-normal font-[Bebas_Neue]">
          Keyboard Controls
        </h2>
        <div class="richtext mt-4 w-full c-#fff c-op-50 text-3.5! lh-1.5em!" v-html="controlExplain" />
        <h3 class="mt-6 text-4 c-#fff c-op-90 font-normal lh-1.5em">
          Please check the Default keyboard controls in the operation bar.
        </h3>
        <p class="text-3.5 c-#fff c-op-50">
          Sign in to Modify and customize your keyboard controls. You can also check out the video tutorial below to know how to do it
        </p>
        <p class="flex flex-wrap">
          <NuxtLink v-for="item in teachVideoLinks" :key="item.name" rel="nofollow" :to="item.href" target="_blank" class="mt-3 text-3.5 c-#fff c-op-90 font-600 transition-300 hover:c-green-5">
            {{ item.name }}
            <SVG_LINK_ICON class="ml-1 mr-6" />
          </NuxtLink>
        </p>
      </div>
      <section class="richtext mt-4">
        <div class="w-full c-#fff c-op-50 text-3.5! lh-1.5em!" v-html="content" />
      </section>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.richtext {
  --at-apply: 'c-#fff c-op-50 text-3! lh-1.5em!';
  word-break: break-word;

  :deep(h2),
  :deep(h3),
  :deep(h4),
  :deep(h5) {
    --at-apply: 'text-6! c-#fff! c-op-90! font-normal! font-[Bebas_Neue] mt-4! lh-1.25em';

    strong {
      --at-apply: 'text-6! font-normal! font-[Bebas_Neue]';
    }

    span {
      --at-apply: 'text-6! font-normal! font-[Bebas_Neue] mb-0!';
    }
  }

  :deep(strong) {
    --at-apply: 'c-#fff! font-normal';
  }
}
</style>
